import { type InfoBlockColor } from '@direct-frontend/components';
import { type OpenApiSchemaAlert } from '#shared/api/schema';

export const dashboardAlertSeverityToColorMap: Record<OpenApiSchemaAlert['severity'], InfoBlockColor> = {
    orange: 'warning',
    red: 'error',
};
